(function () {
  var API = "https://thevaultz.vercel.app/api/subscribe";

  function setMsg(el, text, ok) {
    if (!el) return;
    el.textContent = text || "";
    el.style.color = ok ? "#d4af37" : "#f87171";
    el.hidden = !text;
  }

  function bind(form) {
    if (!form || form.dataset.vaultzBound === "1") return;
    form.dataset.vaultzBound = "1";
    var status = form.querySelector("[data-vaultz-status]");
    var btn = form.querySelector("[type=submit]");

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      setMsg(status, "", true);

      var emailInput = form.querySelector("[name=email]");
      var nameInput = form.querySelector("[name=name]");
      var consent = form.querySelector("[name=consent]");
      var email = (emailInput && emailInput.value ? emailInput.value : "").trim();
      var name = (nameInput && nameInput.value ? nameInput.value : "").trim();

      if (!email) {
        setMsg(status, "Email is required.", false);
        return;
      }
      if (!consent || !consent.checked) {
        setMsg(
          status,
          "Please agree to receive email updates to continue.",
          false
        );
        return;
      }

      var payload = { email: email };
      if (name) payload.name = name;

      if (btn) {
        btn.disabled = true;
        btn.textContent = "Joining…";
      }

      // no-cors + text/plain: request still reaches Vercel even when
      // Access-Control-Allow-Origin is missing. Response is opaque, so we
      // confirm optimistically after a short wait (API accepts this body).
      fetch(API, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "text/plain;charset=UTF-8" },
        body: JSON.stringify(payload),
      })
        .then(function () {
          return new Promise(function (resolve) {
            setTimeout(resolve, 600);
          });
        })
        .then(function () {
          form.reset();
          setMsg(
            status,
            "You're in. Check your inbox for Vaultz10 and vault updates.",
            true
          );
        })
        .catch(function () {
          setMsg(
            status,
            "Network error. Check your connection and try again.",
            false
          );
        })
        .finally(function () {
          if (btn) {
            btn.disabled = false;
            btn.textContent = "Get vault updates";
          }
        });
    });
  }

  function init() {
    document.querySelectorAll("form[data-vaultz-subscribe]").forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
